import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import classNames from "../../utility/classNames";
import BrandLogoMark from "../Shared/Brand/BrandLogoMark";

const ModalSidebar = ({ navigation, sidebarOpen, setSidebarOpen }) => {
  const groupedNavigation = navigation.reduce((acc, item) => {
    if (!acc[item.group]) {
      acc[item.group] = [];
    }
    acc[item.group].push(item);
    return acc;
  }, {});

  return (
    <Dialog
      open={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
      className="relative z-50 lg:hidden"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-ink-900/40 backdrop-blur-sm transition-opacity duration-300 ease-editorial data-[closed]:opacity-0"
      />

      <div className="fixed inset-0 flex">
        <DialogPanel
          transition
          className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-editorial data-[closed]:-translate-x-full"
        >
          <TransitionChild>
            <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-editorial data-[closed]:opacity-0">
              <button
                type="button"
                onClick={() => setSidebarOpen(false)}
                className="-m-2.5 p-2.5"
              >
                <span className="sr-only">Close sidebar</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6 text-white" />
              </button>
            </div>
          </TransitionChild>
          <div className="flex grow flex-col gap-y-6 overflow-y-auto bg-cream-50 px-6 pb-4 border-r border-ink-100">
            <div className="flex h-16 shrink-0 items-center">
              <BrandLogoMark className="h-9 w-auto" />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul className="flex flex-1 flex-col gap-y-5">
                {Object.entries(groupedNavigation).map(
                  ([group, items], groupIndex) => (
                    <li key={group}>
                      <ul className="-mx-2 space-y-0.5">
                        {items.map((item) => (
                          <li key={item.name}>
                            <Link
                              to={item.href}
                              className={classNames(
                                "group relative flex gap-x-3 rounded-md py-2 pl-3 pr-2 text-sm font-medium leading-6 transition-colors",
                                item.current
                                  ? "text-ink-900"
                                  : "text-ink-500 hover:text-ink-900"
                              )}
                              onClick={() => setSidebarOpen(false)}
                            >
                              {item.current && (
                                <span
                                  aria-hidden="true"
                                  className="absolute left-0 top-2 bottom-2 w-[2px] rounded-pill bg-accent-500"
                                />
                              )}
                              <item.icon
                                aria-hidden="true"
                                className={classNames(
                                  "h-5 w-5 shrink-0 mt-0.5",
                                  item.current
                                    ? "text-accent-500"
                                    : "text-ink-400 group-hover:text-ink-700"
                                )}
                              />
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                      {groupIndex <
                        Object.keys(groupedNavigation).length - 1 && (
                        <div className="mt-5 border-t border-ink-100" />
                      )}
                    </li>
                  )
                )}
              </ul>
            </nav>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default ModalSidebar;
